import { render, staticRenderFns } from "./QuestionReadingText.vue?vue&type=template&id=b1581f3c"
import script from "./QuestionReadingText.vue?vue&type=script&lang=js"
export * from "./QuestionReadingText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports